export default __webpack_public_path__ + "static/media/giant.0d199c23.svg";